import HttpApis from "./HttpApis";
const REFRESH_CHECK_INTERVAL = 10000; 

const Auth = {
  signOut() {
    localStorage.removeItem("authData");
  },

  isAuth() {
    return !!localStorage.getItem("authData");
  },

  setToken(data) {
    try {
      localStorage.setItem("authData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    }
  },

  getToken() {
    try {
      const string = localStorage.getItem("authData");
      if (!string) return null;

      return JSON.parse(string);
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  clearStorage() {
    localStorage.clear();
  },

  isTokenExpired(expireDate) {
    if (!expireDate) return true;

    const expiryMs = expireDate * 1000;
    const now = Date.now();

    return now >= expiryMs;
  },

  isTokenExpiringSoon(expireDate) {
    if (!expireDate) return true;

    const expiryMs = expireDate * 1000;
    const now = Date.now();

    return expiryMs - now <= 60 * 60 * 1000;
  },

  async checkAndRefreshOnLoad() {
  const auth = Auth.getToken();
  if (!auth) return;

  const { refresh_token, expire_date } = auth;
  if (!refresh_token) return;
  const isExpired = Auth.isTokenExpired(expire_date);
  const isExpiringSoon = Auth.isTokenExpiringSoon(expire_date);

  if (isExpired || isExpiringSoon) {
    try {
      const res = await HttpApis.refreshToken(refresh_token);

      if (res?.data?.data) {
        const newData = {
          token: res.data.data.token,
          refresh_token: res.data.data.refresh_token,
          expire_date: res.data.data.expire_date,
        };
        Auth.setToken(newData);
      }
    } catch (err) {
      console.error( err);
    }
  }
},

  startAutoRefresh() {
    const intervalId = setInterval(async () => {
      const auth = Auth.getToken();
      if (!auth) return;

      const { refresh_token, expire_date } = auth;
      if (!refresh_token) return;

      const isExpired = Auth.isTokenExpired(expire_date);
      const isExpiringSoon = Auth.isTokenExpiringSoon(expire_date);

      if (isExpired || isExpiringSoon) {
        try {
          const res = await HttpApis.refreshToken(refresh_token);

          if (res?.data?.data) {
            const newData = {
              token: res.data.data.token,
              refresh_token: res.data.data.refresh_token,
              expire_date: res.data.data.expire_date,
            };
            Auth.setToken(newData);
          }
        } catch (err) {
          console.error( err);
        }
      }
    }, REFRESH_CHECK_INTERVAL);
    return intervalId;
  },
};

export default Auth;